/**
 * Created by JIocb on 13.05.2017.
 */
namespace Factive.Game {
    export class DiceData
    {
        protected _color:number  = -1;
        protected _value:number  = -1;
        protected _id:number  = -1;
        protected _index: number = -1;
        btn: PIXI.Sprite;


        public constructor()
        {

        }

        public initialize(color:number,value:number)
        {
            this._color = color;
            this._value = value;
        }

        public get color(): number {
            return this._color;
        }

        public set color(value: number )
        {
            this._color = value;
        }

        public get value(): number {
            return this._value;
        }

        public set value(value: number )
        {
            this._value = value;
        }

        public get id(): number {
            return this._id;
        }

        public set id(value: number )
        {
            this._id = value;
        }

        // public get index(): number {
        //     return this._index;
        // }
        //
        // public set index(value: number )
        // {
        //     this._index = value;
        // }

    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Model/Dice/DiceData.ts